// NAV: ACCOUNT MENU

var fn_nav_accountmenu = function () {

  // > Handling OVERFLOW on BODY
  // Desktop or Mobile (Account menu)
  $('#nav-account-connect').on('shown.bs.dropdown', function () {
    // do something...
    $('body').addClass('overflow-hidden');

  })
  $('#nav-account-connect').on('hidden.bs.dropdown', function () {
    // do something...
    $('body').removeClass('overflow-hidden');

  })

};
